<template>
  <div v-html="dashboardContent"></div>
</template>

<script>
export default {
  name: "DigitalReport",
  data() {
    return {
      company: "",
      country: "",
      dashboardContent: "", // Stores the fetched Company Dashboard HTML
    };
  },
  mounted() {
    this.extractParams();
    this.loadCompanyDashboard();
  },
  methods: {
    extractParams() {
      const pathSegments = window.location.pathname.split("/").filter(Boolean);
      if (pathSegments.length >= 3 && pathSegments[0] === "digitalproduct") {
        this.company = encodeURIComponent(decodeURIComponent(pathSegments[1]));
        this.country = encodeURIComponent(decodeURIComponent(pathSegments[2]));
      }
    },
    async loadCompanyDashboard() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_MASTER_APP_URL
        }company-dashboard/${this.company}/${this.country}`
        );
        if (!response.ok) throw new Error("Failed to load the dashboard");

        this.dashboardContent = await response.text();
      } catch (error) {
        console.error("Error loading company dashboard:", error);
      }
    },
  },
};
</script>
